<template>
  <div>
    <PageAllow controller="FinanceBills" action="edit" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherFinanceMaterialCategory v-model="categorySelected" />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />

              <v-btn
                small
                color="success"
                dark
                class="ms-1"
                @click.stop="save()"
              >
                <v-icon x-small class="pe-1">fas fa-save</v-icon>
                {{ $t("financeBillEdit.save") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="KeyWord = $event"
                    :label="$t('financeBillEdit.keyword')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="editItems"
            :loading="loading"
            :options.sync="options"
            multi-sort
            class="elevation-2 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:top>
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" sm="6" md="4" class="text-no-wrap">
                    <span class="font-weight-bold me-2"
                      >{{ $t("financeBillDetail.obj")
                      }}{{ $t("Global.colon") }}</span
                    >
                    <span v-if="finance_bill.shop">
                      {{
                        finance_bill.shop.shop_name +
                        "(" +
                        finance_bill.shop.shop_code +
                        ")"
                      }}
                    </span>
                    <span v-if="finance_bill.supplier">
                      {{
                        finance_bill.supplier.supplier_name +
                        "(" +
                        finance_bill.supplier.supplier_code +
                        ")"
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 1">
                    <span class="font-weight-bold me-2"
                      >{{ $t("financeBillDetail.org_code")
                      }}{{ $t("Global.colon") }}</span
                    >
                    <span>{{ bill.org_code }}</span>
                    <v-chip
                      v-if="bill.cancel_flg"
                      small
                      label
                      outlined
                      color="danger"
                      class="ms-1 my-n1"
                      >{{ $t("CRUD.cancelled") }}
                    </v-chip>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 2">
                    <span class="font-weight-bold me-2"
                      >{{ $t("financeBillDetail.purchase_bill_code")
                      }}{{ $t("Global.colon") }}</span
                    >
                    <span>{{ bill.bill_code }}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 2">
                    <span class="font-weight-bold me-2"
                      >{{ $t("financeBillDetail.in_code")
                      }}{{ $t("Global.colon") }}</span
                    >
                    <span>{{ bill.org_code }}</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 1">
                    <span class="font-weight-bold me-2">
                      {{ $t("financeBillDetail.sum_price") }}
                      {{ $t("Global.colon") }}
                    </span>
                    <span
                      >{{ $t("Global.money")
                      }}{{ total_price | formatMoney }}</span
                    >
                    <span class="red--text">
                      (
                      {{
                        $t("financeBillDetail.fee") +
                        $t("Global.colon") +
                        $t("Global.money")
                      }}</span
                    >
                    <span class="red--text">{{ fee | formatMoney }} ) </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" v-if="bill.bill_obj_type == 2">
                    <span class="font-weight-bold me-2">
                      {{ $t("financeBillDetail.sum_price_tax") }}
                      {{ $t("Global.colon") }}
                    </span>
                    <span
                      >{{ $t("Global.money")
                      }}{{ total_price | formatMoney }}</span
                    >
                    <span class="red--text">
                      (
                      {{
                        $t("financeBillDetail.fee") +
                        $t("Global.colon") +
                        $t("Global.money")
                      }}</span
                    >
                    <span class="red--text">{{ fee | formatMoney }} ) </span>
                  </v-col>
                </v-row>
                <!-- settings &&
                    settings.bill_credential_type &&
                    settings.bill_credential_type.shop_bill == '12' -->
                <v-row dense class="px-1" v-if="bill.bill_obj_type == 1">
                  <v-spacer />
                  <v-col cols="12" sm="12" md="4">
                    <span class="transparent--text font-weight-bold me-2">
                      {{ $t("financeBillDetail.sum_price") }}
                      {{ $t("Global.colon") }}
                    </span>
                    <span class="transparent--text"
                      >{{ $t("Global.money")
                      }}{{ total_price | formatMoney }}</span
                    >
                    <span class="red--text">
                      (
                      {{
                        $t("ReceiptDetail.logistics_fee") + $t("Global.colon")
                      }}</span
                    >
                    <span class="red--text">
                      <span style="width: 20px">
                        <v-text-field
                          v-model="logistics_fee"
                          :placeholder="
                            String(
                              $numberFormatter.formatTwoDot(logistics_fee, 2)
                            )
                          "
                          single-line
                          dense
                          hide-details
                          type="number"
                          min="0"
                          :prefix="$t('Global.money')"
                          @blur="
                            logistics_fee =
                              $numberFormatter.formatWithDotNoMoreThan(
                                Number(logistics_fee),
                                2
                              )
                          "
                          style="width: 60px"
                          class="d-inline-flex"
                        />
                      </span>
                      )
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <template v-slot:item.total="{ item }">
              {{ $t("Global.money") }}
              {{ (item.num * item.price) | formatMoneyFloor }}
            </template>

            <!-- 单价 -->
            <template v-slot:item.price="{ item }">
              <v-text-field
                v-model="item.price"
                :placeholder="
                  String($numberFormatter.formatTwoDot(item.price, 2))
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.price = $numberFormatter.formatWithDotNoMoreThan(
                    Number(item.price),
                    2
                  )
                "
              />
            </template>
            <!-- 数量 -->
            <template v-slot:item.num="{ item }">
              <v-text-field
                v-model="item.num"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                @blur="
                  item.num = $numberFormatter.formatWithDotNoMoreThan(
                    Number(item.num),
                    2
                  )
                "
              />
            </template>
            <!-- 备注 -->
            <template v-slot:item.actions="{ item }">
              <v-text-field
                v-model="item.memo"
                single-line
                dense
                hide-details
                style="max-width: 120px"
              >
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="
                      detail_memo_item = item;
                      memoDialog = true;
                    "
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-edit
                  </v-icon>
                </template>
              </v-text-field>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>

    <!-- 备注弹窗 -->
    <v-dialog v-model="memoDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span class="d-inline-block text-center" style="max-width: 360px">
            {{ $t("financeBillEdit.memo") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memoDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memoDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherFinanceMaterialCategory from "@/components/plugins/SearcherFinanceMaterialCategory";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import FinanceBills from "@/api/finance_bills";

const defaultOptions = {
  category_ids: null,
  keyword: "",
};

export default {
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    categorySelected: null,
    editItems: [],
    detail_memo_item: { memo: "" },
    memoDialog: false,
    bill: {},
    finance_bill: {},
    logistics_fee: 0,
    total_price: null,
    fee: null,
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherFinanceMaterialCategory,
    SearcherKeyword,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.inanceReceipt"),
        disabled: false,
        href: "/finance-receipt",
      },
      {
        text: i18n.t("Nav.financeBillEdit"),
        disabled: true,
      },
    ],

    headers() {
      return [
        {
          text: i18n.t("financeBillEdit.Fields.material_category"),
          align: "start",
          sortable: false,
          value: "material.material_category.name",
        },
        {
          text: i18n.t("financeBillEdit.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "content",
        },
        {
          text: i18n.t("financeBillEdit.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material.material_code",
        },
        {
          text: i18n.t("financeBillEdit.Fields.num"),
          align: "start",
          sortable: false,
          value: "num",
          width: "120px",
        },
        {
          text: i18n.t("financeBillEdit.Fields.price"),
          align: "end",
          sortable: false,
          value: "price",
          width: "120px",
        },
        {
          text: i18n.t("financeBillEdit.Fields.sum"),
          align: "end",
          sortable: false,
          value: "total",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },

    ...mapState(["loading", "settings"]),
  },

  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        keyword: this.KeyWord,
      });
      this.getFinanceBill();
    },
    resetSearch() {
      this.categorySelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    getFinanceBill() {
      FinanceBills.fetchOne(this.$route.params.id, this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.finance_bill.bill.status != 1) {
              this.$router.push("/finance-bills");
            }
            this.finance_bill = response.data.finance_bill;
            this.bill = response.data.finance_bill.bill;
            this.editItems = response.data.finance_bill.finance_bill_details;
            this.logistics_fee = response.data.finance_bill.logistics_fee;
          }
        }.bind(this)
      );
    },

    save() {
      // console.log(this);
      var data = [];
      var finance_bill_details = [];
      this.editItems.map((e) => {
        data.push({
          id: e.id,
          num: e.num,
          price: e.price,
          total: this.$numberFormatter.formatMoneyFloor(e.num * e.price),
          memo: e.memo,
        });
      });
      finance_bill_details.push(data);

      FinanceBills.edit(this.$route.params.id, {
        finance_bill_details: finance_bill_details[0],
        logistics_fee: this.logistics_fee,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            window.parent.parent.location.href = "/#/finance-bills";
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getFinanceBill();
      },
    },
    categorySelected: {
      handler() {
        // console.log(this.);
        this.options.category_ids = this.categorySelected
          ? this.categorySelected.id
          : null;
      },
    },
    editItems: {
      deep: true,
      handler() {
        var total_price = 0;
        this.editItems.forEach((item) => {
          total_price += parseFloat(
            this.$numberFormatter.formatMoneyFloor(item.num * item.price)
          );
        });
        total_price = parseFloat(total_price.toFixed(2));
        this.fee = total_price;
        this.total_price = Number(total_price) + Number(this.logistics_fee);
      },
    },
    logistics_fee: {
      deep: true,
      handler() {
        var total_price = 0;
        this.editItems.forEach((item) => {
          total_price += parseFloat(
            this.$numberFormatter.formatMoneyFloor(item.num * item.price)
          );
        });
        total_price = parseFloat(total_price.toFixed(2));
        this.fee = total_price;
        this.total_price = Number(total_price) + Number(this.logistics_fee);
      },
    },
  },
};
</script>

<style>
</style>